import React from "react"

import DeltaiLogo from "../../../images/png/deltai.png"

const Logo = () => {
  return <img src={DeltaiLogo} alt="deltai logo" width="150px" />
}

export default Logo
